export const matchIn = (staticValue,value) => {
  let matched = false;
  let propertiesToMatch = staticValue.replace(/ /g,'');
  propertiesToMatch = propertiesToMatch.split(",");
  value = value.replace(/ /g,'');
  Array.isArray(propertiesToMatch) && propertiesToMatch.map((p, index) => {
      if(p == value) {
          matched = true;
      }
  })
  if (matched) {
      return true;
  }
  return false;
}